import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from "./_pages/login/login.component";
import { ExplorePageComponent } from './_pages/explore-page/explore-page.component';
import { DashboardPageComponent } from './_pages/dashboard-page/dashboard-page.component';
import { MySalesPageComponent } from "./_pages/my-sales-page/my-sales-page.component";
import { SellerPageComponent } from "./_pages/seller-page/seller-page.component";
import { ComparePageComponent } from "./_pages/compare-page/compare-page.component";
import { SellerSearchPageComponent } from "./_pages/seller-search-page/seller-search-page.component";
import { SellerRankingPageComponent } from "./_pages/seller-ranking-page/seller-ranking-page.component";
import { ListingsSearchPageComponent } from "./_pages/listings-search-page/listings-search-page.component";
import { FaqPageComponent } from "./_pages/faq-page/faq-page.component";
import { RecommendationsPageComponent } from "./_pages/recommendations-page/recommendations-page.component";

const routes: Routes = [
  { path: '', component: DashboardPageComponent },
  { path: 'login', component: LoginComponent },
  { path: 'explore', component: ExplorePageComponent },
  { path: 'my-sales', component: MySalesPageComponent},
  { path: 'seller', component : SellerPageComponent },
  { path: 'compare', component : ComparePageComponent },
  { path: 'seller-search', component : SellerSearchPageComponent },
  { path: 'seller-ranking', component : SellerRankingPageComponent },
  { path: 'listings-search', component: ListingsSearchPageComponent},
  { path: 'faq', component: FaqPageComponent},
  { path: 'recommendations', component: RecommendationsPageComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation:'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
